/*@ngInject*/
const InviteChatRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.sendChatInvitation = function (submissionId, userIds, message) {
        let url = '/rest/ChatRoom/' + submissionId + '/invite',
            config = {
                params: {
                    userIds: userIds,
                    message: message
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('inviteChatRepository', InviteChatRepository);
